import React from "react";
import { Layout } from "../components/common";
import Footer from "../components/Footer/Footer";
import Header from "../components/modules/Auth/Header";
import { NotFound as NotFoundContent } from "../components/modules/NotFound";

const NotFound = () => (
  <Layout
    header={<Header />}
    content={<NotFoundContent />}
    footer={<Footer />}
  />
);

export default NotFound;
